import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartTreemap"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21 1.5H3C2.60232 1.50046 2.22105 1.65864 1.93984 1.93984C1.65864 2.22105 1.50046 2.60232 1.5 3V21C1.50046 21.3977 1.65864 21.7789 1.93984 22.0602C2.22105 22.3414 2.60232 22.4995 3 22.5H21C21.3977 22.4995 21.7789 22.3414 22.0602 22.0602C22.3414 21.7789 22.4995 21.3977 22.5 21V3C22.4995 2.60232 22.3414 2.22105 22.0602 1.93984C21.7789 1.65864 21.3977 1.50046 21 1.5ZM21 10.5H17.25V3H21V10.5ZM12 3H15.75V10.5H12V3ZM10.5 3V15H3V3H10.5ZM3 16.5H10.5V21H3V16.5ZM12 21V12H21V21H12Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartTreemap.vue"]]);
